<template>
    <div class="p-grid p-jc-center">
        <div class="card p-fluid" style="width:22rem;">
            <div>
                <h5>Login to Admin</h5>
                <form @submit.prevent="signIn">
                    <div class="p-field">
                        <label for="email">Email</label>
                        <InputText id="email" type="email" v-model="form.email" placeholder="Enter Email" />
                    </div>
                    <div class="p-field">
                        <label for="password">Password</label>
                        <InputText id="password" type="password" v-model="form.password" placeholder="Enter Password" />
                    </div>
                    <Button label="Login" type="submit" />
                    <span class="sso-login-label">or login with</span>
                    <div class="sso-wrapper">
                        <Button @click="signInWithGoogle" type="button" class="p-button-outlined sso-button"
                            label="Sign in via Google">
                            <svg height="100%" viewBox="0 0 20 20" width="25px" fit=""
                                preserveAspectRatio="xMidYMid meet" focusable="false">
                                <path
                                    d="M19.6 10.23c0-.82-.1-1.42-.25-2.05H10v3.72h5.5c-.15.96-.74 2.31-2.04 3.22v2.45h3.16c1.89-1.73 2.98-4.3 2.98-7.34z"
                                    fill="#4285F4"></path>
                                <path
                                    d="M13.46 15.13c-.83.59-1.96 1-3.46 1-2.64 0-4.88-1.74-5.68-4.15H1.07v2.52C2.72 17.75 6.09 20 10 20c2.7 0 4.96-.89 6.62-2.42l-3.16-2.45z"
                                    fill="#34A853"></path>
                                <path
                                    d="M3.99 10c0-.69.12-1.35.32-1.97V5.51H1.07A9.973 9.973 0 000 10c0 1.61.39 3.14 1.07 4.49l3.24-2.52c-.2-.62-.32-1.28-.32-1.97z"
                                    fill="#FBBC05"></path>
                                <path
                                    d="M10 3.88c1.88 0 3.13.81 3.85 1.48l2.84-2.76C14.96.99 12.7 0 10 0 6.09 0 2.72 2.25 1.07 5.51l3.24 2.52C5.12 5.62 7.36 3.88 10 3.88z"
                                    fill="#EA4335"></path>
                            </svg>
                            <span>Google</span>
                        </Button>
                        <Button @click="signInWithMicrosoft" class="p-button-outlined sso-button">
                            <svg height="100%" viewBox="0 0 20 20" width="25px" fit=""
                                preserveAspectRatio="xMidYMid meet" focusable="false">
                                <g fill="none">
                                    <path d="M0 0h9.504v9.504H0z" fill="#F25022"></path>
                                    <path d="M10.496 0H20v9.504h-9.504z" fill="#7FBA00"></path>
                                    <path d="M0 10.496h9.504V20H0z" fill="#00A4EF"></path>
                                    <path d="M10.496 10.496H20V20h-9.504z" fill="#FFB900"></path>
                                </g>
                            </svg>
                            <span>Microsoft</span>
                        </Button>
                    </div>

                </form>
                <span class="p-button-link p-button" style="padding:0; margin-top:1rem;"
                    @click="forgotPassword = true">Forgot
                    Password?</span>
                <Message style="margin-bottom:0;" :closable="false" severity="error" v-if="error">{{ error }}</Message>
                <button class="p-sm-12 p-d-block p-mt-2 p-button p-text-center" @click="handleLink('google.com')"
                    v-if="errorLink">Link My Google Account</button>
                <button class="p-sm-12 p-d-block p-mt-2 p-button p-text-center" @click="handleLink('microsoft.com')"
                    v-if="errorLink">Link My Microsoft Account</button>
                <Message style="margin-bottom:0;" :closable="false" severity="error" v-if="requireSSO">
                    You must login via Single sign-on, to link a google account <a href=""
                        @click.prevent="linkGoogle">click here</a>, alternatively to link a microsoft account <a href=""
                        @click.prevent="linkMicrosoft">here</a>.
                </Message>
            </div>
            <Dialog header :visible.sync="forgotPassword" modal class="" @hide="resetError = null">
                <template #header>
                    <h5 style="margin:0;">Reset Password</h5>
                </template>
                <form @submit.prevent="resetPassword">
                    <div class="p-field">
                        <label for="email">Email</label>
                        <InputText id="email" type="email" v-model="resetEmail" placeholder="Enter Email" />
                    </div>
                    <Button label="Reset" type="submit" />
                </form>
                <template #footer>
                    <span class="p-button-link p-button" style="padding:0; margin-top:1rem;"
                        @click="forgotPassword = false, resetError = null">Go Back</span>
                    <Message style="margin-bottom:0;" :closable="false" severity="error" v-if="resetError">{{ resetError
                        }}</Message>
                </template>
            </Dialog>
            <Toast />
        </div>

    </div>
</template>

<script>
import { mapMutations } from "vuex";
import { auth, db, firebaseApp } from '@/firebase';
import {
    signInWithPopup,
    getAuth,
    linkWithCredential,
    OAuthProvider,
    signInWithEmailAndPassword,
    linkWithPopup
} from "firebase/auth";
import firebase from 'firebase/compat/app'
import store from '@/stores/store';
import axios from 'axios';

export default {

    name: 'Login',
    mounted() {
        this.recaptchaVerifier = new auth.RecaptchaVerifier("recaptcha-container", {
            "size": "normal",
            "callback": function (response) {
                console.log(response);
            }
        }, firebaseApp);
    },
    data() {
        return {
            form: {
                email: "",
                password: ""
            },
            error: null,
            forgotPassword: false,
            resetEmail: '',
            resetError: null,
            pendingCred: null,
            errorLink: false,
            requireSSO: false,
        }
    },
    methods: {
        ...mapMutations({
            setLoggedIn: 'SET_LOGGED_IN',
            setUser: 'SET_USER'
        }),
        async linkMicrosoft() {
            const provider = new OAuthProvider('microsoft.com');
            const auth = getAuth();
            try {
                const result = await linkWithPopup(auth.currentUser, provider);
                this.requireSSO = false;
            } catch (error) {
                this.requireSSO = false;
                this.error = error.message;
            }

        },
        async linkGoogle() {
            const provider = new OAuthProvider('google.com');
            const auth = getAuth();
            try {
                const result = await linkWithPopup(auth.currentUser, provider);
                this.requireSSO = false;
            } catch (error) {
                this.requireSSO = false;
                this.error = error.message;
            }
        },
        async handleLink(providerName = null) {
            try {
                //Sign the user in using their chosen method.
                debugger;
                if (providerName) {
                    const provider = new OAuthProvider(providerName)
                    let result = await signInWithPopup(getAuth(), provider);
                } else {
                    let result = await signInWithEmailAndPassword(getAuth(), this.form.email, this.form.password)
                }

                //Link to the Microsoft credential.
                let pendingCred = this.pendingCred;

                if (pendingCred !== null) {
                    // As you have access to the pending credential, you can directly call the
                    // link method.
                    let user = await linkWithCredential(result.user, pendingCred);
                    this.userLookUp(result.user.email);
                }

                // Step 7: Continue to app.
            } catch (error) {
                this.error = error.message
            }
        },
        signInWithMicrosoft() {
            const provider = new firebase.auth.OAuthProvider('microsoft.com');
            auth.signInWithPopup(provider).then((result) => {
                //User is signed in
                //IdP data available in result.additionalUserInfo.profile
                //Get the OAuth access token and ID token
                const accessToken = result.credential.accessToken;
                const idToken = result.credential.idToken;
                this.userLookUp(result.user.email);
            }).catch((error) => {
                //Handle the error
                this.error = error.message;
                console.log(error);
                if (error.code == "auth/account-exists-with-different-credential") {
                    this.pendingCred = error.credential;
                    this.errorLink = true;
                }

            })
        },
        signInWithGoogle() {
            const provider = new firebase.auth.GoogleAuthProvider();
            auth.signInWithPopup(provider).then((result) => {
                let userEmail = result.user.email; // Capture user email for easier debugging
                this.userLookUp(userEmail);
            }).catch((error) => {
                this.error = "An error was encountered signing you in via Google";
            });
        },
        userLookUp(userEmail) {
            let userDocRef = db.collection('users').doc(userEmail);

            userDocRef.get().then((docSnapshot) => {
                if (docSnapshot.exists) {
                    this.setLoggedIn(true)
                    this.setUser(docSnapshot.data());
                    store.dispatch("fetchUser", docSnapshot.data()).then(() => {
                        this.$router.push({ name: 'dashboard' });
                    });
                    this.error = null;
                    this.errorLink = false;
                    //this.$router.push('/');
                } else {
                    this.error = "There is no user record corresponding to this identifier. The user may have been deleted."
                }
            }).catch((error) => {
                console.log(error);
                this.error = "An error was encountered retrieving the users details";
            });
        },
        signIn() {
            auth.signInWithEmailAndPassword(this.form.email, this.form.password).then((response) => {
                let data;
                let settings = db.collection('users').doc(response.user.email);
                settings.get().then((doc) => {
                    data = doc.data()
                    const client = db.collection('clients').doc(data.client.key);
                    client.get().then((docSnapshot) => {
                        let clientDoc = docSnapshot.data();
                        if (clientDoc.requireSSO) {
                            this.requireSSO = true;
                        } else {

                            store.dispatch("fetchUser", data).then(() => {
                                this.$router.push({ name: 'dashboard' });
                            });
                        }
                    });
                }).catch((error) => {
                    this.error = error.message
                });
            }).catch((error) => {
                this.error = error.message;
            });
        },
        resetPassword() {
            const passwordResetUrl = process.env.VUE_APP_API_URL + '/reset-password';

            axios({
                method: 'post',
                url: passwordResetUrl,
                data: {
                    'email': this.resetEmail
                }
            }).then((response) => {
                if (typeof(response.data) == 'object') {
                    this.resetError = response.data.message;
                } else {
                    this.resetEmail = '';
                    this.forgotPassword = false;
                    this.resetError = false;
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Password Reset sent - check your email.', life: 3000 });
                }
            }).catch(error => { this.resetError = error.message; });
        }
    }
}
</script>

<style lang="scss">
.reset_password {
    position: absolute;
    top: 70px;
    width: 22rem;

    .p-dialog-content {
        padding-bottom: 0;
    }

    .p-dialog-footer {
        text-align: left;
    }
}

.sso-login-label {
    margin: 10px 0px;
    text-align: center;
    display: block;
    width: 100%;
    position: relative;

    &:after,
    &:before {
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        position: absolute;
        display: block;
        content: "";
        width: 75px;
        height: 2px;
        background: #f2f2f2;
    }

    &:after {
        left: auto;
        right: 0;
    }
}

.sso-wrapper {
    display: flex;
    justify-content: space-between;
}

.sso-button {
    display: flex;
    align-items: center;
    width: 48% !important;

    span {
        margin-left: 10px;
    }
}
</style>